import { tokens } from '@equinor/eds-tokens';

var _tokens$colors = tokens.colors,
  primary100 = _tokens$colors.infographic.primary__moss_green_100.rgba,
  _tokens$colors$intera = _tokens$colors.interactive,
  icon_on_interactive_colors = _tokens$colors$intera.icon_on_interactive_colors.rgba,
  danger_resting = _tokens$colors$intera.danger__resting.rgba;
var primary = {
  background: primary100
};
var neutral = {
  background: icon_on_interactive_colors
};
var tertiary = {
  background: danger_resting
};

export { neutral, primary, tertiary };
